import { NewPasswordRequest } from './../../../models/requests/newpassword.request';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import axios from '../../axios';

type InitialState = {
  loading: boolean;
  data?: { success: boolean };
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};
const newPasswordRequest = async (request: NewPasswordRequest) => {
  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/consume-link-hash`, request);
  return response.status;
};
export const newPassword = createAsyncThunk(
  'newPassword',
  async (request: NewPasswordRequest, { dispatch }) => {
    // TODO Activate newPassword logic
    const status = await newPasswordRequest(request);
    if (status !== 200) {
      return { success: false };
    }
    // LocalStorage.set(LocalStorage.token, response.token);
    // await getMeRequest(dispatch);
    // return response;
    // await Helpers.wait(1000);
    // dispatch(setMe({ email: '' }));
    return { success: true };
  }
);

const newPasswordSlice = createSlice({
  name: 'newPassword',
  initialState,
  reducers: {
    newPasswordReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(newPassword.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      newPassword.fulfilled,
      (state, action: PayloadAction<{ success: boolean }>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(newPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default newPasswordSlice.reducer;
export const { newPasswordReset } = newPasswordSlice.actions;
